export interface TimeLogCreateDto {
    projectId: string;
    logStarted: string;
    logEnded?: string;
    description?: string;
    userSub?: string;
}

export interface TimeLogPostDto {
    id: string;
    userSub: string;
    projectId: string;
    logStarted: Date;
    logEnded?: Date;
    description?: string;
    createdAt?: Date;
}

export enum TimeLogStatus {
    UNSUBMITTED = 'UNSUBMITTED',
    SUBMITTED = 'SUBMITTED',
}

export type TimeLogDto = {
    id: string;
    userSub: string;
    projectId: string;
    clientId?: string;
    logStarted: string;
    logEnded?: string;
    description?: string;
    createdAt?: string;
    status: TimeLogStatus;
};

export type SubmissionIntervalPostDto = {
    id: string;
    userSub: string;
    projectId: string;
    startDate: Date;
    endDate: Date;
};

export type SubmitTimelogDto = {
    projectId: string;
    month: string;
    year: number;
};

export type PatchTimelogDto = {
    logStarted?: string;
    logEnded?: string;
    description?: string;
};

export type SubmitTimelogByOwnerDto = {
    userSub: string;
    projectId: string;
    month: string;
    year: number;
};

export interface MonthlySubmitEntryDto {
    projectId: string;
    date: string;
    hours: string;
}

export interface MonthlySubmitRequestDto {
    entries: MonthlySubmitEntryDto[];
    timezone?: string;
}

export interface MonthlySubmitRejectedEntryDto {
    projectId: string;
    date: string;
    hours: string;
    reason: string;
    code?: string;
}

export interface MonthlySubmitResponseDto {
    processedCount: number;
    skippedCount: number;
    rejectedCount: number;
    finalEntries: MonthlySubmitEntryDto[];
    rejectedEntries: MonthlySubmitRejectedEntryDto[];
}

export type TimeLogDailySum = {
    day: string;
    hours: number;
};

export type ProjectHoursSummaryWithPercentageDto = {
    projectId: string;
    totalSubmittedHours: number;
    percentageChange: number;
    changeDirection: 'up' | 'down' | 'same';
};

export type UserTimeLogRateBreakdownDto = {
    hourlyRate: number | null;
    totalSubmitted: number;
    totalUnsubmitted: number;
};

export type TimeLogSummaryHoursDto = {
    totalSubmitted: number;
    totalUnsubmitted: number;
    currentMonthHours: number;
    totalLoggedHours: number;
    rateBreakdown?: UserTimeLogRateBreakdownDto[];
};
